
import { useBlogTextMaterials } from '@entities/Blog'

import type { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'

import { BlogCarousel } from '@widgets/blog-carousel'
import { BlogPreview } from '@widgets/blog-preview'





export default function TextMaterialsBlock ({ payload, block }: BlockProps) {
  const { textMaterials, loading } = useBlogTextMaterials({ ids: payload?.ids as string[] })

  const { subtype = 'block' } = block

  const name = payload?.name && (payload.name as string).length > 0 ? payload.name as string : undefined

  if (subtype === 'block') {
    return <BlogCarousel title={name} articles={textMaterials} loading={loading} />
  }

  return (
    <div className={styles.root__blog}>
      <BlogPreview
        title={name}
        articles={textMaterials}
        loading={loading}
      />
    </div>
  )
}
